import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import "./List.vue?vue&type=style&index=0&id=d35b97c0&lang=scss&scoped=true"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35b97c0"]])

export default __exports__